import { css } from '@emotion/css'
import { fontFamily, fontSize, spacing } from '../../styles'
import getThemeColors, { colors } from '../../themes'

const styles = {
  link: css({
    display: 'flex',
    alignItems: 'center',
    fontFamily: fontFamily.body,
    fontWeight: 'inherit',
    cursor: 'pointer',
    userSelect: 'none',
    textDecoration: 'none',
    whiteSpace: 'nowrap',

    '&:hover': {
      textDecoration: 'underline',
    },

    '&:focus': {
      outline: 'none',
      textDecoration: 'underline',
    },

    '&:active': {
      textDecoration: 'underline',
    },

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  disabled: css({
    pointerEvents: 'none',
    cursor: 'default',
    opacity: 0.3,
  }),

  badge: css({
    flexGrow: 0,
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  }),
}

export default styles

export const linkSize = size => {
  switch (size) {
    case 'small':
      return css({
        fontSize: fontSize.small,
      })

    default:
      return css({
        fontSize: fontSize.default,
      })
  }
}

export const linkTheme = (theme, withBackground) => {
  const themed = getThemeColors(theme)

  let iconHoverBackground = {}
  if (withBackground) {
    iconHoverBackground = {
      '& > div': {
        backgroundColor: themed.base,

        '& svg': {
          color: colors.white,
        },
      },
    }
  }

  // The light theme is a special case
  if (theme === 'light') {
    return css({
      color: colors.jumbo,

      '&:hover': iconHoverBackground,

      '&:active': {
        color: themed.dark,
      },
    })
  }

  return css({
    color: themed.base,

    '&:hover': iconHoverBackground,

    '&:active': {
      color: themed.dark,
    },
  })
}

export const badgeSize = size => {
  switch (size) {
    case 'small':
      return css({
        width: 20,
        height: 20,
      })

    case 'medium':
      return css({
        width: 30,
        height: 30,
      })

    default:
      return css({
        width: 24,
        height: 24,
      })
  }
}

export const badgeTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    backgroundColor: themed.light,
  })
}

export const iconSize = size => {
  switch (size) {
    case 'small':
      return 12

    case 'medium':
      return 16

    default:
      return 14
  }
}

export const iconTheme = theme => {
  const themed = getThemeColors(theme)
  return themed.base
}
